var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-footer",
    { attrs: { fixed: "", height: "auto" } },
    [
      _c(
        "v-card",
        { staticClass: "flex", attrs: { flat: "", tile: "" } },
        [
          _c(
            "v-card-actions",
            {
              staticClass: " justify-center",
              staticStyle: {
                "background-color": "#dbdbdc !important",
                padding: "11px",
                color: "#515a75",
                "box-shadow": "0px 1px 3px 0px rgba(0, 0, 0, 0.2)"
              }
            },
            [
              _vm._v("\n      ©2018 — "),
              _c("strong", [_vm._v("ELECTORAL LITERACY CLUB")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-780cf0c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-780cf0c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/ElcFooter.vue
// module id = null
// module chunks = 